export default __webpack_public_path__ + "static/media/avatar_178.8398ad10.png";